module.exports = __webpack_public_path__ + "static/media/slider-5.98c5dfb7.jpg";